import FESCODDLOGO from "../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../images/discologos/hesco logo.png";
import IESCODDLOGO from "../images/discologos/iesco logo.png";
import LESCODDLOGO from "../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../images/discologos/pesco1.jpg";
import QESCODDLOGO from "../images/discologos/qesco.png";
import SEPCODDLOGO from "../images/discologos/sepco.jpg";
import TESCODDLOGO from "../images/discologos/tesco.jpg";
import SUNDARLOGO from "../images/discologos/sundar-logo.png";

/** Distribution companies shown in code-10 admin company dropdown */
export const DISCO_COMPANIES = [
  { code: "11", name: "LESCO", logo: LESCODDLOGO },
  { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
  { code: "13", name: "FESCO", logo: FESCODDLOGO },
  { code: "14", name: "IESCO", logo: IESCODDLOGO },
  { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
  { code: "26", name: "PESCO", logo: PESCODDLOGO },
  { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
  { code: "37", name: "HESCO", logo: HESCODDLOGO },
  { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
  { code: "48", name: "QESCO", logo: QESCODDLOGO },
  { code: "59", name: "TESCO", logo: TESCODDLOGO },
  { code: "91", name: "SUNDAR", logo: SUNDARLOGO },
];

/**
 * Fallback label/value pairs for admin company dropdowns.
 * Live lists come from getCompanyDetails via allCompaniesAPI / companySelectOptions cache.
 * Keep ENABLED_DISCO_COMPANY_CODES allow-list in utils/adminCompany.js unchanged.
 */
export const ADMIN_COMPANY_SELECT_OPTIONS = [
  { value: "10", label: "PITC" },
  { value: "11", label: "LESCO" },
  { value: "12", label: "GEPCO" },
  { value: "13", label: "FESCO" },
  { value: "14", label: "IESCO" },
  { value: "15", label: "MEPCO" },
  { value: "26", label: "PESCO" },
  { value: "27", label: "HAZECO" },
  { value: "37", label: "HESCO" },
  { value: "38", label: "SEPCO" },
  { value: "48", label: "QESCO" },
  { value: "59", label: "TESCO" },
  { value: "91", label: "SUNDAR" },
];
